// extracted by mini-css-extract-plugin
module.exports = {"vRed4":"#ff4e1f","error":"MessengerMenuError_error__2-VbZ","errorIcon":"MessengerMenuError_errorIcon__2Rm_1"};